// 资源组
export interface IResourceGroupCreate {
  readonly objectGroupName: string;
  readonly parentId: number;
}

export interface IResourceGroupDelete {
  readonly objectGroupId: Array<number>;
}

// 资源对象
export interface IResourceObjectCreate {
  readonly data: Array<number>;
  readonly objectId: number;
  readonly objectName: string;
  readonly objectKey: string;
}

export interface IResourceObjectDelete {
  readonly objectId: Array<number>;
}

export interface IResourceObjectUpdate {
  readonly objectId: number;
  readonly objectName: string;
  readonly objectKey: string;
}

export enum IPermissionResourceType {
  Create = 'create',
  Edit = 'edit',
  Delete = 'delete',
}
